import * as yup from "yup";
import BundleKey from "../../translation/bundleKey";

export const driverLicenseNewVehicleSchema = (translate: any) => {
  const schema = yup.object().shape({
    driverLicenseExpirationDate: yup
      .string()
      .required(translate(BundleKey.ERROR_VEHICLE_LICENSE_MUST)),
  });
  return schema;
};
